import * as React from 'react';

import cn from 'clsx';
import { Typography } from '../../../Typography';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';

export interface IHeaderLinkProps {
  href: string;
  name: string;
  isActive: boolean;
}

export const HeaderLink: React.FC<IHeaderLinkProps> = props => {
  const { isActive, name, href } = props;
  const fontWeight = isActive ? 'bold' : 'normal';
  const deviceType = useDeviceType();

  return (
    <a href={href} className={cn(styles['link'], isActive && styles['active'])}>
      <Typography.Text color="currentColor" fontWeight={fontWeight} level={deviceType === 'desktop' ? 1 : 3}>
        {name}
      </Typography.Text>
    </a>
  );
};

HeaderLink.displayName = 'HeaderLink';
